import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import Card from "@mui/material/Card";

import PageHeader from "pages/components/PageHeader";
import VendasMensaisVendedoresDashboard from "pages/components/VendasMensaisVendedoresDashboard";

export default function VendasMensaisVendedores() {
  return (
    <DashboardLayout>
      <DashboardNavbar />

      <PageHeader />

      <MDBox pt={2} pb={3}>
        <Card>
          <MDBox p={2}>
            <VendasMensaisVendedoresDashboard height="32rem" fullscreen />
          </MDBox>
        </Card>
      </MDBox>
    </DashboardLayout>
  );
}
